export const AppConfig = {
  hidePermitHolder:
    process.env.REACT_APP_HIDE_PERMIT_HOLDER === 'true' ? true : false
}
